// extracted by mini-css-extract-plugin
export default {"root":"Header_root__pAOt2","toolbar":"Header_toolbar__Az8D-","tenantCard":"Header_tenantCard__xf-7v"};